<template>
  <v-theme-provider>
    <!-- Banner de nova versão -->
    <v-card
      v-if="showBanner && isOnline"
      style="
        position: fixed;
        bottom: 0;
        right: 0;
        margin: 15px;
        z-index: 6;
        max-width: 350px;
      "
    >
      <v-alert dense text color="success" class="mb-0">
        <div style="padding-right: 50px">
          <h6 class="mb-1" style="font-weight: 900">
            <v-icon class="mr-1" color="success">mdi-update</v-icon>
            Nova versão disponível!
          </h6>
          <div class="d-flex gap-2">
            <v-btn
              :loading="loading"
              text
              @click="updateApp"
              small
              :disabled="loading"
            >
              <v-icon small left>mdi-download</v-icon>
              Atualizar agora
            </v-btn>
          </div>
        </div>
      </v-alert>
    </v-card>
  </v-theme-provider>
</template>

<script>
export default {
  name: "UpdateBanner",
  data() {
    return {
      showBanner: false,
      showOfflineBanner: false,
      showStatsDialog: false,
      newWorker: null,
      newVersion: null,
      currentVersion: null,
      cacheStats: null,
      loading: false,
      clearingCache: false,
      warmingCache: false,
      isOnline: navigator.onLine,
      isProduction: process.env.NODE_ENV === "production",
    };
  },
  methods: {
    onSWUpdated(event) {
      this.newWorker = event.detail;
      this.showBanner = true;

      if (this.newWorker) {
        this.newWorker.postMessage({ type: "CHECK_VERSION" });
      }
    },

    onNewVersionAvailable(event) {
      this.newWorker = event.detail.waiting;
      this.showBanner = true;

      if (this.newWorker) {
        this.newWorker.postMessage({ type: "CHECK_VERSION" });
      }
    },

    onSWMessage(event) {
      const { data } = event;

      switch (data.type) {
        case "NEW_VERSION_AVAILABLE":
          this.newVersion = data.version
            ? data.version.substring(0, 8)
            : "nova";
          this.showBanner = true;
          break;

        case "VERSION_INFO":
          this.currentVersion = data.currentVersion;
          this.cacheStats = data.cacheStats;
          break;

        case "FORCE_RELOAD":
          if (data.success) {
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
          break;

        case "CACHE_WARMED":
          this.warmingCache = false;
          break;

        case "CACHE_CLEARED":
          this.clearingCache = false;
          this.requestCacheStats();
          break;

        case "MESSAGE_ERROR":
          this.loading = false;
          this.clearingCache = false;
          this.warmingCache = false;
          break;
      }
    },

    async updateApp() {
      if (!this.newWorker && !navigator.serviceWorker.controller) {
        return;
      }

      this.loading = true;

      try {
        if (this.newWorker) {
          this.newWorker.postMessage({ type: "SKIP_WAITING" });

          setTimeout(() => {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({
                type: "FORCE_UPDATE",
              });
            } else {
              window.location.reload();
            }
          }, 500);
        } else {
          navigator.serviceWorker.controller.postMessage({
            type: "FORCE_UPDATE",
          });
        }

        // Timeout de segurança
        setTimeout(() => {
          if (this.loading) {
            window.location.reload();
          }
        }, 8000);
      } catch (error) {
        this.loading = false;
      }
    },
  },

  mounted() {
    window.addEventListener("swUpdated", this.onSWUpdated);
    window.addEventListener("newVersionAvailable", this.onNewVersionAvailable);

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", this.onSWMessage);
    }
  },

  beforeDestroy() {
    window.removeEventListener("swUpdated", this.onSWUpdated);
    window.removeEventListener(
      "newVersionAvailable",
      this.onNewVersionAvailable
    );

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("message", this.onSWMessage);
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}
</style>
